import { useMutation, useQuery } from "react-query"
import { useQueryContext } from "../../../contexts/query"
import { putApi } from "../../fetch-api/put"
import { normalFetch } from "../../fetch-api/get"

export const fixerKeys = {
    getFixerSettings: 'getFixerSettings',
    setFixerSettings: 'setFixerSettings'
}

// Get response data sample:
// {
//     "success": true,
//         "message": "فرآیند مورد نظر با موفقیت انجام شد",
//             "data": [
//                 {
//                     "currency": "aed",
//                     "feeFactorBuy": 1,
//                     "feeFactorSell": 1,
//                     "isActive": true
//                 }
//             ]
// }

export const useGetFixerSettings = () => {

    return useQuery(
        fixerKeys.getFixerSettings, () => normalFetch('settings/fixer'),
        {
            select: res => res?.data?.data
        }
    )
}


// Payload body sample:
// [
//     {
//         "currency": "aed",
//         "feeFactorBuy": 1,
//         "feeFactorSell": 1,
//         "isActive": true
//     }
// ]

export const useSetFixerSettings = (onSuccess) => {

    const { setToast, queryClient } = useQueryContext()

    return useMutation(
        fixerKeys.setFixerSettings, (payload) => putApi(payload, 'settings/fixer'),
        {
            onSuccess: () => {
                queryClient.invalidateQueries([fixerKeys.getFixerSettings])
                setToast({ message: 'op-success', show: true, isError: false })
                onSuccess()
            }
        }
    )
}
